import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=6997bf7a&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style0 from "./Layout.vue?vue&type=style&index=0&id=6997bf7a&scoped=true&lang=scss&"
import style1 from "./Layout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6997bf7a",
  null
  
)

export default component.exports